module.exports = __webpack_public_path__ + "static/media/finishessay.com.f42fe8c0.png";